import { useWidget } from '@telescope/cassini-hooks';
import { Box, Flex, useBreakpointValue } from '@telescope/cassini-ui';
import { getAppConfig } from '@telescope/cassini-utilities';
import { AdUnit, AdUnitSize, FallbackError, PreviewAlert } from 'components';
import { Footer, Header } from 'features';
import { Open } from 'generated-types/widget';
import { useEffect } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet } from 'react-router-dom';
import { AdUnitData } from 'types';
import { isIframed, loadWidgetFonts } from 'utils';

const isAppIframed = isIframed();
const { isPreviewUrl } = getAppConfig();

export const AppShell = () => {
  const { data } = useWidget<Open>({ select: (data: Open) => data.widget });
  const { fonts: accountFonts, globalViews, campaignFonts, ads } = data!;
  const { sitewide } = globalViews;
  const adSize: AdUnitSize = useBreakpointValue({ base: 'mobileLeaderboard', md: 'leaderboard' })!;
  const headerAd: AdUnitData = ads.header[adSize];
  const footerAd: AdUnitData = ads.footer[adSize];
  const breakpoint = useBreakpointValue(['base', null, 'md', 'lg']) as string;

  useEffect(() => {
    loadWidgetFonts({ ...accountFonts, ...campaignFonts });
  }, [accountFonts, campaignFonts]);

  return (
    <Flex direction="column" minH={isAppIframed ? 'auto' : '100vh'} {...sitewide.styles.app}>
      <PreviewAlert isPreview={isPreviewUrl} />
      <AdUnit size={adSize} alignSelf="center" my={[2, 4]} {...headerAd}></AdUnit>
      <Header />
      <Box as="main" flex={isAppIframed ? 0 : 1} overflowX="hidden" {...sitewide.styles.main[breakpoint]}>
        <ErrorBoundary FallbackComponent={FallbackError}>
          <Outlet />
        </ErrorBoundary>
      </Box>
      <AdUnit size={adSize} alignSelf="center" my={[2, 5]} {...footerAd}></AdUnit>
      <Footer />
    </Flex>
  );
};
